import { render, staticRenderFns } from "./registerTips.vue?vue&type=template&id=48246312&scoped=true"
import script from "./registerTips.vue?vue&type=script&lang=js"
export * from "./registerTips.vue?vue&type=script&lang=js"
import style0 from "./registerTips.vue?vue&type=style&index=0&id=48246312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48246312",
  null
  
)

export default component.exports